import { render, staticRenderFns } from "./com-config-items-2.vue?vue&type=template&id=5051a506&scoped=true"
import script from "./com-config-items-2.vue?vue&type=script&lang=js"
export * from "./com-config-items-2.vue?vue&type=script&lang=js"
import style0 from "./com-config-items-2.vue?vue&type=style&index=0&id=5051a506&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051a506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5051a506')) {
      api.createRecord('5051a506', component.options)
    } else {
      api.reload('5051a506', component.options)
    }
    module.hot.accept("./com-config-items-2.vue?vue&type=template&id=5051a506&scoped=true", function () {
      api.rerender('5051a506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/com-config-items-2.vue"
export default component.exports